import { Tabs } from "@ofqual/portal-components/components/Tabs";
import React, { useState } from "react";
import { useAuth } from "@ofqual/portal-core/core/hooks/useAuth";
import {
  FormStateIndicator,
  FormStateIndicatorProps,
} from "../common/FormStateIndicator";
import { authSelector } from "../../redux/selectors";
import { UserType } from "@ofqual/portal-activity-feed/activityfeed/redux/state";

type ItemTabsProps = {
  indicatorProps: FormStateIndicatorProps;
  children: (activeTab: "ao" | "ofqual") => React.ReactNode;
};

export const ItemTabs: React.FC<ItemTabsProps> = ({
  children,
  indicatorProps,
}) => {
  const [tabValue, setTabValue] = useState<"ao" | "ofqual">("ao");
const { userType } = useAuth(authSelector);
const isOfqual = userType === UserType.Ofqual;

  return (
    <>
      <Tabs
        currentTabId={tabValue}
        onTabChange={(newTabId: any) => setTabValue(newTabId)}
        tabs={
          isOfqual
            ? [
                {
                  id: "ao",
                  label: (
                    <div style={{ display: "inline-flex" }}>
                      AO Details&nbsp;
                      <FormStateIndicator {...indicatorProps} />
                    </div>
                  ),
                  dataTest: "ao-tab",
                },
                {
                  id: "ofqual",
                  label: (
                    <div style={{ display: "inline-flex" }}>
                      Ofqual Details&nbsp;
                      <FormStateIndicator {...indicatorProps} />
                    </div>
                  ),
                  dataTest: "ofqual-tab",
                },
              ]
            : [{ id: "ao", label: "AO Details" }]
        }
      />
      {children(tabValue)}
    </>
  );
};
